const binding = { modules: {}, dataActions: {} };

    (binding.modules['sysco-business-sign-up'] = {
        c: () => require('partner/modules/sysco-business-sign-up/sysco-business-sign-up.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'sysco-business-sign-up',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/sysco-business-sign-up'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|sysco-business-sign-up|sysco-business-sign-up'] = {
                c: () => require('partner/modules/sysco-business-sign-up/sysco-business-sign-up.view.tsx'),
                cn: '__local__-__local__-sysco-business-sign-up'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };